<template>
  <v-card class="menu-item rounded-xl" elevation="0" :to="{name: itemMenu.to}">
    <div class="menu-item__content">
      <div class="menu-item__icon-wrapper">
        <component :is="itemMenu.icon" class="menu-item__icon"></component>
      </div>
      <p class="menu-item__label primary--text font-weight-bold text-center mb-0">
        {{ itemMenu.name }}
      </p>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MenuItem",
  components: {
    IconPackages: () => import("./icons/IconPackages"),
    IconCustomers: () => import("./icons/IconCustomers"),
    IconChargers: () => import("./icons/IconCharges"),
    IconUsers: () => import("./icons/IconUsers"),
    IconMenuInternetMovil: () => import("./icons/IconMenuInternetMovil"),
    IconBill: () => import("./icons/IconCharges"),
    IconTemporalClients: () => import("./icons/IconTemporalClients")
  },
  props: {
    itemMenu: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  background: #ffffff;
  border: 1px solid #e8e9ed;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(46, 52, 122, 0.12);
    border-color: #c5c7d4;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 28px 16px 24px;
    gap: 16px;
  }

  &__icon-wrapper {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__icon {
    width: 100%;
    height: 100%;
  }

  &__label {
    font-size: 0.8rem;
    letter-spacing: 0.04em;
    line-height: 1.3;
  }
}

@media (min-width: 600px) {
  .menu-item {
    &__content {
      padding: 36px 20px 32px;
      gap: 20px;
    }

    &__icon-wrapper {
      width: 88px;
      height: 88px;
    }

    &__label {
      font-size: 0.85rem;
    }
  }
}

@media (min-width: 960px) {
  .menu-item {
    &__content {
      padding: 44px 24px 36px;
      gap: 24px;
    }

    &__icon-wrapper {
      width: 100px;
      height: 100px;
    }

    &__label {
      font-size: 0.9rem;
    }
  }
}
</style>
